import { Country } from '@enmon/commons/lib/enmon';
import { Select, type SelectProps } from 'antd';
import type { VFC } from 'react';
import type { DefaultOptionType } from 'antd/lib/select';
import type { StrictOmit } from '@enmon/commons';
import { filterOption, filterSort } from '../utils';

export const getCountryOptions = (countries?: readonly Country[]) =>
  (countries ?? Object.values(Country)).map<DefaultOptionType>(country => ({
    value: country,
    label: country.toUpperCase(),
  }));

export interface CountrySelectProps extends StrictOmit<SelectProps<number>, 'options'> {
  onChange?: (value: number | null) => void;
  /** Used to select lower subset of Country enum values. */
  options?: readonly Country[];
}

export const CountrySelect: VFC<CountrySelectProps> = ({ onChange, options, ...propsToPass }) => {
  return (
    <Select
      showSearch
      filterOption={filterOption}
      filterSort={filterSort}
      options={getCountryOptions(options)}
      onSelect={(id?: number) => onChange?.(id)}
      {...propsToPass}
    />
  );
};
